import { CommonColumns } from "packages/services/common/common-columns.entity";
import { Column, Entity, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { JobworkCreationEntity } from "../../job-work/job-work-creation/entity/job-work-creation-entity";

@Entity('vendor_registration')
export class VendorsEntity extends CommonColumns {

  @PrimaryGeneratedColumn("increment", {
    name: 'id'
  })
  id: number;

  @Column("varchar", {
    name: "vendor_name",
    length: 100,
  })
  vendorName: string;

  @Column("varchar", {
    name: "phone_number",
    length: 100,
  })
  phoneNumber: string;

  @Column("varchar", {
    name: "email",
    length: 100,
  })
  email: string;

  @Column("varchar", {
    name: "contact_person_name",
    length: 100,
  })
  contactPerson: string;

  @Column("varchar", {
    name: "status",
    length: 100,
    default: 'PENDING'
  })
  status: string;

  @Column("varchar", {
    name: "address",
    length: 200,
  })
  address: string;

  // @Column("varchar",{
  //   name: "remarks",
  //   length: 100,
  // })
  // remarks: string;

  // @OneToMany(() => JobworkCreationEntity, (jobwork) => jobwork.vendor)
  // jobworkId: JobworkCreationEntity[];

}